<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-layout wrap justify-space-between xl12>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtsigmno" label="Search By IGM"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtsblno" label="Search By BL"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtscont_no" label="Search By Container"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
            </v-alert>
            <v-alert :value="alerterror" color="error" icon="new_releases">
                <ul>
                    <li>{{ errorMessage }}</li>
                </ul>
            </v-alert>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <h3 class="py-4">Arrival Notice Details</h3>
                        <export-excel
                            title = "VCFS Arrival Details"
                            :data   = "igm_arrival_notices">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table  :headers="headers" :items="igm_arrival_notices" :search="search" class="elevation-1"
                    :rows-per-page-items = "[15, 25, 50, 100]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.vessel }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.voyage_no }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.berthed_on }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.bond_no }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.terminal }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.streamer_agent }}</td>
                            <td class="text-xs-right">{{ props.item.an_data.destination_cfs }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtigmno" label="IGM No" :rules="[(v) => !!v || 'IGM Number is required']" autofocus required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-menu v-model="dpigm" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dtigm" label="IGM Date" prepend-icon="event" readonly
                                            v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dtigm" @input="dpigm = false"  :rules="[(v) => !!v || 'IGM Date is required']"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-menu v-model="dpbrethed_on" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dtbrethed_on" label="Vessel Berthed On" prepend-icon="event" readonly
                                            v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dtbrethed_on" @input="dpbrethed_on = false"  :rules="[(v) => !!v || 'IGM Number is required']"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-select v-model="cbovessel" :items="vessel_list" item-value="id" label="Select Vessel" item-text="text"  :rules="[(v) => !!v || 'Vessel is required']"></v-select>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtvoyageno" label="Voyage"  :rules="[(v) => !!v || 'Voyage No is required']" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtblnumber" label="Bill of Lading No." :rules="[(v) => !!v || 'BL is required']" required ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtbondno" label="Bond Number"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-select v-model="cboterminal" :items="terminal_list" item-value="id"  label="Select Terminal" :rules="[(v) => !!v || 'Terminal is required']" item-text="text"></v-select>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtstreamer_agent" label="Streamer Agent" ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-card justify-center>
                                <v-card-text primary-title v-for="(cont, index) in conts" v-bind:key="index">
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="cont.cont_no" label="Container Number"  :rules="[(v) => !!v || 'Container Number is required']" :counter="11" autocapitalize="words" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-select v-model="cont.size_type" :items="sizetype_list" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Sizetype is required']"  label="Sizetype"></v-select>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-btn color="info" v-if="index + 1 === conts.length" v-on:click="addConts()">Add New</v-btn>
                                            <v-btn color="error" @click="removeLine(index)">Remove</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                    <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'importarrival',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            errorMessage: null,
            seen: true,
            search: null,
            igm_arrival_notices: [],
            conts: [],
            dtigm: new Date().toISOString().substr(0, 10),
            dtbrethed_on: new Date().toISOString().substr(0, 10),
            bl_date: new Date().toISOString().substr(0, 10),
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtigmno: null,
            dpigm: false,
            dpbrethed_on: false,
            cbovessel: null,
            txtvoyageno: null,
            txtbondno: null,
            txtblnumber: null,
            cboterminal: null,
            txtstreamer_agent: null,
            txtsigmno: null,
            txtsblno: null,
            txtscont_no: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            pagination: {
                page: 1,
                rowsPerPage: 10,
                totalItems: 0
            },
            search: '',
            headers: [
              { text: 'S.No', sorting: false, align: 'left' },
              { text: 'IGM No', align: 'right', value: 'igm_no_key' },
              { text: 'IGM Date', align: 'right', value: 'igm_date_key' },
              { text: 'BL No', align: 'right', value: 'bl_no_key' },
              { text: 'Container No', align: 'right', value: 'cont_no_key' },
              { text: 'Size Type', align: 'left', value: 'sizetype_key' },
              { text: 'Vessel', align: 'right', value: 'vessel_key' },
              { text: 'Voyage', align: 'right', value: 'voyage_no_key' },
              { text: 'Berthed On', align: 'right', value: 'berthed_on_key' },
              { text: 'Bond No', align: 'right', value: 'bond_key' },
              { text: 'Terminal', align: 'right', value: 'terminal_key' },
              { text: 'Streamer Agent', align: 'right', value: 'streamer_agent_key' },
              { text: 'Dest. CFS', align: 'right', value: 'destination_cfs_key' },
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getVessel(),
        this.getTerminal(),
        this.getSizeType(),
        this.addConts()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        addConts: function () {
            let checkEmptyLines = this.conts.filter(cont => cont.number === null)

            if (checkEmptyLines.length >= 1 && this.conts.length > 0) return
                this.conts.push({
                    cont_no: null,
                    size_type: null,
                    cargo_description: null,
                    created_by: localStorage.username
                })
        },
        removeLine (contId) {
          if (!this.blockRemoval) this.conts.splice(contId, 1)
        },
        getData: function () {
            this.loading = true;
            if (this.txtsigmno) {
                this.API_URL = this.$hostname + "/igm_arrival_notices?igm_no=" + this.txtsigmno
            } else if (this.txtsblno) {
                this.API_URL = this.$hostname + "/igm_arrival_notices?bl_no=" + this.txtsblno
            } else if (this.txtscont_no) {
                this.API_URL = this.$hostname + "/igm_arrival_notices?cont_no=" + this.txtscont_no
            } else {
                this.API_URL = this.$hostname + "/igm_arrival_notices?limit=15"
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.igm_arrival_notices = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const arrival_notice = {'crossDomain': true,
                                    'igm_no': this.txtigmno,
                                    'igm_date': this.dtigm,
                                    'berthed_on': this.dtbrethed_on,
                                    'vessel': this.cbovessel,
                                    'voyage_no': this.txtvoyageno,
                                    'bond_no': this.txtbondno,
                                    'terminal': this.cboterminal,
                                    'streamer_agent': this.txtstreamer_agent,
                                    'destination_cfs': 'INTUTVIL1',
                                    'bl_no': this.txtblnumber,
                                    'created_by': localStorage.username}
            const data = {
                "arrival_notice": arrival_notice,
                "cont_data": this.conts
            }
            axios.post(this.$hostname + '/igm_arrival_notices', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    this.alertsmessage = response.data.message;
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = true;
                    this.errorMessage = error.response.data.message;
                    window.scrollTo(0, 0);
                })
        },
        getVessel: function () {
            this.API_URL = this.$hostname + "/combos/vessel"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.vessel_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        getTerminal: function () {
            this.API_URL = this.$hostname + "/combos/terminal"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.terminal_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        getSizeType: function () {
            this.API_URL = this.$hostname + "/combos/sizetype"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.sizetype_list = response.data;
            }, (error) => {
                this.error = true;
            })
        },
        clearData: function() {
            this.txtigmno = null;
            this.dpigm = null;
            this.dpbrethed_on = null;
            this.cbovessel = null;
            this.txtvoyageno = null;
            this.txtbondno = null;
            this.txtblnumber = null;
            this.cboterminal = null;
            this.txtstreamer_agent = null;
            this.txtsigmno = null;
            this.txtsblno = null;
            this.txtscont_no = null;
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay 
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
     
</style>
